import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Skeleton from '../../../componentsv2/Skeleton';
import Layout from '../../../componentsv2/Layout';

export default function GlobalAccountsSkeleton() {
  return (
    <Layout>
      <Grid item xs={12}>
        <Grid container rowSpacing={2}>
          <Grid item xs={6} md={9} sx={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
            <Skeleton variant="rectangular" width="40%" height="36px" animation="wave" />
            <Skeleton variant="rectangular" width="40%" height="21px" animation="wave" />
          </Grid>
          <Grid item xs={6} md={3} sx={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end' }}>
            <Skeleton variant="rectangular" width="100%" height="32px" animation="wave" />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '1em 2em',
                width: '100%',
              }}
            >
              <Grid container rowSpacing={2}>
                <Grid item xs={12}>
                  <Skeleton variant="rectangular" width="100%" height="500px" animation="wave" />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}
